import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '@components/Icon';
import SEO from '@components/seo/SEO';
import LanguageSwitcher from '@components/LanguageSwitcher';
import { BackTop, Drawer } from 'antd';

// 创建图标封装组件，与LandingPage中相同
const SafeIcon = ({ icon: IconName, useFa = true, ...props }) => {
  if (typeof IconName === 'string' && Icon[IconName]) {
    const IconComponent = Icon[IconName];
    return <IconComponent useFa={useFa} {...props} />;
  }
  
  if (typeof IconName === 'function' || typeof IconName === 'object') {
    return <IconName useFa={useFa} {...props} />;
  }
  
  return null;
};

const Copyright = () => {
  const { t } = useTranslation('pages');
  const { t: tCommon } = useTranslation('common');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <SEO 
          title={t('copyright.seo.title')}
          description={t('copyright.seo.description')}
          keywords={t('copyright.seo.keywords')}
          canonicalUrl="https://snapbeautify.pixzens.com/copyright"
      />
      {/* 导航栏 */}
      <header className="bg-white dark:bg-gray-900 shadow-sm">
        <div className="container mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <Link to="/" className="flex items-center text-2xl font-bold text-purple-600 dark:text-purple-400">
                <img src="/favicon.svg" alt={t('about.logoText')} width="32" height="32" className="mr-2" />
                {t('about.logoText')}
              </Link>
            </div>
            <nav className="hidden md:flex items-center space-x-8">
              <Link to="/" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="Home" size={16} className="mr-1" />
                {tCommon('home')}
              </Link>
              <Link to="/quick-start" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="BookOpen" size={16} className="mr-1" />
                {tCommon('quickStart')}
              </Link>
              <Link to="/about" className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center">
                <SafeIcon icon="User" size={16} className="mr-1" />
                {tCommon('about')}
              </Link>
              <LanguageSwitcher />
            </nav>
            <div className="flex md:hidden">
              <button 
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                onClick={() => setMobileMenuOpen(true)}
              >
                <SafeIcon icon="Menu" size={24} />
              </button>
            </div>
          </div>
        </div>
        
        {/* 移动设备导航菜单 */}
        <Drawer
          title={tCommon('navigation')}
          placement="right"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          width={250}
        >
          <div className="flex flex-col space-y-4">
            <Link 
              to="/" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Home" size={16} className="mr-1" />
              {tCommon('home')}
            </Link>
            <Link 
              to="/quick-start" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="BookOpen" size={16} className="mr-1" />
              {tCommon('quickStart')}
            </Link>
            <Link 
              to="/about" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="User" size={16} className="mr-1" />
              {tCommon('about')}
            </Link>
            <Link 
              to="/features" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="Star" size={16} className="mr-1" />
              {tCommon('features')}
            </Link>
            <Link 
              to="/faq" 
              className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              <SafeIcon icon="HelpCircle" size={16} className="mr-1" />
              {tCommon('faq')}
            </Link>
            <div className="pt-2 border-t border-gray-200 dark:border-gray-700">
              <LanguageSwitcher />
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 my-2 pt-2">
              <Link 
                to="/privacy" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Shield" size={16} className="mr-1" />
                {tCommon('privacy')}
              </Link>
              <Link 
                to="/terms" 
                className="font-medium text-gray-700 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="FileText" size={16} className="mr-1" />
                {tCommon('terms')}
              </Link>
              <Link 
                to="/copyright" 
                className="font-medium text-purple-600 dark:text-purple-400 flex items-center py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <SafeIcon icon="Award" size={16} className="mr-1" />
                {tCommon('copyright')}
              </Link>
            </div>
          </div>
        </Drawer>
      </header>

      {/* 主要内容区域 */}
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 flex items-center">
              <SafeIcon icon="Award" className="mr-3 text-purple-600 dark:text-purple-400" size={28} />
              {t('copyright.title')}
              <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-4">{t('copyright.updateDate')}</span>
            </h1>

            <div className="prose dark:prose-invert max-w-none">
              <p className="text-gray-600 dark:text-gray-300">
                {t('copyright.intro')}
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Copyright" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                {t('copyright.sections.snapbeautifyIP.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                {t('copyright.sections.snapbeautifyIP.description')}
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="Upload" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                {t('copyright.sections.userUploadedContent.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                {t('copyright.sections.userUploadedContent.description')}
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="AlertTriangle" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                {t('copyright.sections.infringementComplaint.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300">
                {t('copyright.sections.infringementComplaint.description')}
              </p>

              <h2 className="text-xl font-semibold mt-8 mb-4 text-gray-800 dark:text-white flex items-center">
                <SafeIcon icon="MessageCircle" className="mr-2 text-purple-500 dark:text-purple-400" size={20} />
                {t('copyright.sections.contactUs.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mt-2 flex items-center">
                <SafeIcon icon="Mail" size={16} className="mr-2 text-purple-500 dark:text-purple-400" />
                <a href="mailto:support@pixzens.com" className="text-purple-600 dark:text-purple-400 hover:underline">support@pixzens.com</a>
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* 页脚区域 */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <Link to="/" className="flex items-center text-xl font-bold text-white">
                <img src="/favicon.svg" alt={t('about.logoText')} width="24" height="24" className="mr-2" />
                {t('about.logoText')}
              </Link>
            </div>
            
            <div className="flex space-x-8">
              <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors text-sm">{tCommon('privacy')}</Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors text-sm">{tCommon('terms')}</Link>
              <Link to="/copyright" className="text-gray-300 hover:text-white transition-colors text-sm">{tCommon('copyright')}</Link>
            </div>
            
            <div className="mt-4 md:mt-0 text-gray-400 text-sm">
              © {new Date().getFullYear()} {t('about.logoText')} | SnapBeautify
            </div>
          </div>
        </div>
      </footer>
      
      <BackTop>
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-purple-600 hover:bg-purple-700 text-white shadow-lg">
          <SafeIcon icon="ChevronUp" size={20} />
        </div>
      </BackTop>
    </div>
  );
};

export default Copyright; 